import React from 'react';
import ReactDOM from 'react-dom';

/**
 * A reusable confirmation modal component using React Portal
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onClose - Function to call when closing the modal
 * @param {function} props.onConfirm - Function to call when confirming the action
 * @param {string} props.title - Modal title
 * @param {string} props.message - Modal message
 * @param {string} props.confirmText - Text for the confirm button
 * @param {string} props.cancelText - Text for the cancel button
 * @param {string} props.className - Base class name for styling (will be prefixed to all class names)
 * @returns {React.ReactPortal|null} - The modal portal or null if closed
 */
const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = 'Confirm', 
    message = 'Are you sure?',
    confirmText = 'Confirm', 
    cancelText = 'Cancel',
    className = 'feature-requests' 
}) => {
    if (!isOpen) return null;

    // Create portal to render modal at the end of the document body
    return ReactDOM.createPortal(
        <div className={`${className}-modal-overlay`}>
            <div className={`${className}-modal-content`}>
                <h3>{title}</h3>
                {typeof message === 'string' ? (
                    <p>{message}</p>
                ) : (
                    message
                )}
                <div className={`${className}-modal-buttons`}>
                    <button 
                        className={`${className}-cancel-modal-button`}
                        onClick={onClose}
                    >
                        {cancelText}
                    </button>
                    <button 
                        className={`${className}-confirm-modal-button`}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmationModal; 